<script>
    import { filters, studies, filterCategories } from '../store';
    import Study from '../Study.svelte';
    import Loader from '../shared/Loader.svelte';
    import { flip } from 'svelte/animate';
import { onMount } from 'svelte';

    let windowSize;
    let animating = false;
    const DURATION = 300;
    let isLoading = true;
    let showPrevGrad = false;
    let showNextGrad = true;
    let filterNav;

    function handleFilter(cat) {
        if(animating) return;

        if($filters.includes(cat)){
            $filters = $filters.filter( (f) => {
                return f !== cat;
            } )
        }else {
            $filters = [...$filters, cat];
        }
    }

    function clickBlock() {
        animating = true;
        
        setTimeout(() => animating = false, DURATION);
    }

    function checkFilters($filters){
        clickBlock();
        let tempStudies = $studies;

        tempStudies.map( s => {
            if($filters.length === 0) return s.show = true;
            let hasOne = false;

            for(let i=0; i<s.technologies.length; i++) {
                if($filters.includes(s.technologies[i].name)) {
                    hasOne = true;
                    break;
                }
            }

            if(hasOne) return s.show = true;
            return s.show = false;
        })

        $studies = tempStudies;
    }

    $: checkFilters($filters);

    function checkFiltersNavScroll(e) {
        if(windowSize > 768) return false;

        if(e.target.scrollLeft > 2) {
            console.log('### shoe prev grad')
            showPrevGrad = true;
        } else {
            showPrevGrad = false;
        }

        if(e.target.scrollWidth - ( e.target.offsetWidth + 2 ) <= e.target.scrollLeft ) {
            console.log('### hide end gradient')
            showNextGrad = false;
        } else {
            showNextGrad = true;
        }
    }

    function clearFilters() {
        $filters = [];

        if(windowSize <= 768) {
            filterNav.scrollTo(0,0);
        }
    }

    onMount(async() => {
        try{
            const response = await fetch('https://andrereitz.com.br/wp-json/reitz/studies');
    
            if(response.ok) {
                const data = await response.json();
                studies.set(data.map( d => ({...d, show: true}) ));
            } else {
                throw new Error(response.status + " Failed Fetch");
            }
        } catch(err) {
            console.log('Error: ', err)
        } finally {
            isLoading = false;
        }
    })
</script>

<svelte:window bind:innerWidth={windowSize} />

<div class="container">
    <h2><span class="font-light">My</span> Studies</h2>
    <div class="filter-nav" class:showPrevGrad={showPrevGrad} class:showNextGrad={showNextGrad}>
        {#if $filterCategories.length > 0}
        <h4>
            { #if $filters.length === 0 }
                Filter:
            { :else }
                <span on:click="{ () => clearFilters() }">Clear filters</span>
            { /if }
        </h4>
            <ul class="filter" on:scroll="{(e) => checkFiltersNavScroll(e, this)}" bind:this={filterNav}>
                { #each $filterCategories as cat }
                    <li on:click="{ () => handleFilter(cat.name) }" data-filter="{cat.name}" class="{ $filters.includes(cat.name) ? 'active' : '' }">{ cat.name }</li>
                { /each }
            </ul>
        {:else}
            <Loader text='Loading filters' />
        {/if}
    </div>
    <div class="studies">
        { #each $studies.filter( s => s.show == true) as study (study.id) }
            <div class="study-container" animate:flip="{{ duration: DURATION }}">
                <Study {study} />
            </div>
        { /each }
        {#if isLoading}
            <div class="loader-wrapper">
                <Loader centered spinnerBg="#808080" />
            </div>
        {/if}
        {#if $studies.filter( s => s.show == true).length === 0 && !isLoading}
            No study with selected filters
        {/if}
    </div>
</div>

<style lang="less">
    .filter-nav {
        display: flex;
        align-items: center;
        
        h4 {
            width: auto;
            display: inline-block;
            font-size: 18px;
            line-height: 28px;
            color: var(--color-gray-200);
            font-weight: 300;
            letter-spacing: 3px;
            margin: 0;
            white-space: nowrap;

            span {
                letter-spacing: 2px;
                cursor: pointer;
            }
        }
        ul {
            flex: 3 1 100%;
            width: 100%;
            display: inline-block;
            margin-left: 15px;

            li {
                float: left;
                padding: 5px 15px;
                border-radius: 500px;
                border: 1px solid var(--color-gray-300);
                margin-right: 10px;
                color: var(--color-gray-350);
                cursor: pointer;
                margin: 5px 10px 5px 0;

                &.active {
                    color: var(--color-white);
                    background: linear-gradient(135deg, #9D34CE 0.42%, #A65FD6 0.43%, #0F90C0 100%);
                }
            }
        }

        @media screen and (max-width: 768px) {
            flex-flow: row wrap;
            position: relative;

            &.showPrevGrad:before {
                content: '';
            }
            &.showNextGrad:after {
                content: '';
            }
            &:before, &:after {
                position: absolute;
                bottom: 0;
                background: white;
                width: 30px;
                height: 52px;
            }
            &:before {
                left: -5px;
                background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
            }
            &:after {
                right: -5px;
                background: linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
            }

            h4,
            ul {
                flex: 1 1 100%;
            }
            ul {
                margin: 5px 0 0 0;
                padding-bottom: 5px;
                display: flex;
                overflow-x: auto;
                scroll-snap-type: x mandatory;

                &::-webkit-scrollbar {
                    display: none;
                }
                li {
                    scroll-snap-align: start;
                }
            }
        }
    }
    .studies {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;

        .study-container {
            flex: 0 1 calc( ~'50% - 15px');
            display: flex;

            @media screen and (max-width: 768px) {
                flex: 1 1 100%;
            }
        }
        .loader-wrapper {
            min-height: 300px;
            width: 100%;
            display: flex;
        }
    }
</style>